export const GET_ITEM_SELLABILITY_ESTIMATE_SUCCESS = 'GET_ITEM_SELLABILITY_ESTIMATE_SUCCESS'
export const GET_ITEM_SELLABILITY_ESTIMATE_ERROR = 'GET_ITEM_SELLABILITY_ESTIMATE_ERROR'

export const CACHE_MAP_DRAWER_RESULT = 'CACHE_MAP_DRAWER_RESULT'

export const cacheMapDrawerResult = (result) => {
  return { type: CACHE_MAP_DRAWER_RESULT, result }
}
